import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import disneyBannerVideoDesktop from '../../../styles/theme/disney/TOY5_PJ15_pl-PL_Poland_Post_Dub_HD_2398_Stereo_Online_Master.mp4';
import disneyBannerVideoMobile from '../../../styles/theme/disney/TOY5_PJ15_pl_PL_Poland_POST_DUB_9x16_2398_Stereo_Online_Master.mp4';

import styles from '../MainSlider.styl';

const cx = classNames.bind(styles);

export default function DisneyBannerVideoSlide({ isActive, isPhone, onEnded }) {
  const videoRef = useRef(null);
  const videoSrc = isPhone ? disneyBannerVideoMobile : disneyBannerVideoDesktop;

  useEffect(() => {
    const video = videoRef.current;

    if (!video) {
      return undefined;
    }

    const tryPlay = () => {
      if (!isActive) {
        return;
      }

      const playPromise = video.play();

      if (playPromise) {
        playPromise.catch(() => {});
      }
    };

    if (isActive) {
      video.currentTime = 0;
      tryPlay();

      if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
        video.addEventListener('loadeddata', tryPlay, { once: true });

        return () => {
          video.removeEventListener('loadeddata', tryPlay);
        };
      }
    } else {
      video.pause();
    }

    return undefined;
  }, [isActive]);

  useEffect(() => {
    const video = videoRef.current;

    if (!video || !onEnded) {
      return undefined;
    }

    video.addEventListener('ended', onEnded);

    return () => {
      video.removeEventListener('ended', onEnded);
    };
  }, [onEnded]);

  return (
    <video
      ref={videoRef}
      className={cx('MainSlider__item-img', 'MainSlider__item-video', {
        'MainSlider__item-img_active': isActive,
      })}
      src={videoSrc}
      muted
      playsInline
      preload="auto"
      aria-hidden
    />
  );
}

DisneyBannerVideoSlide.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isPhone: PropTypes.bool.isRequired,
  onEnded: PropTypes.func,
};

DisneyBannerVideoSlide.defaultProps = {
  onEnded: null,
};
